import { createFileRoute } from "@tanstack/react-router";
import { PakistanMatrixPage } from "@/components/pakistan/PakistanMatrixPage";
import { goldRatesQueryOptions } from "@/lib/nonblocking-rates";
import { SITE_URL, DEFAULT_OG_IMAGE, hreflangLinks } from "@/lib/seo";

const PATH = "/pakistan/21k";

export const Route = createFileRoute("/pakistan/21k")({
  loader: ({ context }) => context.queryClient.prefetchQuery(goldRatesQueryOptions),
  head: () => {
    const title = `21K Gold Rate in Pakistan Today — Live Per Tola & Per Gram | 21 Carat Sona Ka Bhao`;
    const description = `Live 21K (87.5% pure) gold rate in Pakistan — Gulf-style jewellery-grade 21 carat sona ka bhao per tola, per 10 gram and per gram across every major sarafa bazaar. Refreshed every 10 minutes.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: `${SITE_URL}${PATH}` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_PK" },
        { property: "og:image", content: DEFAULT_OG_IMAGE },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }, ...hreflangLinks(PATH)],
    };
  },
  component: () => (
    <PakistanMatrixPage
      mode={{ kind: "karat", karat: "21k" }}
      h1="21K Gold Price in Pakistan Today — Live Rate"
      intro="Live 21K (87.5% pure) gold rate for every Pakistani sarafa bazaar. Common for imported Gulf-style jewellery. Per tola, per 10 gram, per gram — updated every 10 minutes from international spot + USD/PKR."
    />
  ),
});